import { createFeatureSelector, createSelector } from '@ngrx/store';
import { handleActions } from 'redux-actions';
import { includes, trim } from 'lodash';
import {
  BrowserManagerActionsEnum,
  SetBrowserData,
  SetDeviceId,
} from '../actions';
import { IBrowserInfoHeaders } from '../browser-manager.data';

// feature name
export const BROWSER_MANAGER = 'browser_manager';

export interface IBrowserInfo {
  isMobile: boolean;
  isTablet: boolean;
  isMacOS: boolean;
  isIE: boolean;
  isFirefox: boolean;
  isOnline: boolean;
  device: string;
  platform: string;
  browserInfoHeaders: IBrowserInfoHeaders;
}

// state definition
export interface IBrowserState {
  deviceId: string;
  browserData: IBrowserInfo;
}

// initial state
export const initialState: IBrowserState = {
  deviceId: null,
  browserData: null,
};

// reducer
export const reducerFn = handleActions(
  {
    [BrowserManagerActionsEnum.SET_DEVICE_ID]: function (
      state: IBrowserState,
      { payload }: SetDeviceId
    ): IBrowserState {
      return {
        ...state,
        deviceId: payload.deviceId,
      };
    },
    [BrowserManagerActionsEnum.SET_BROWSER_DATA]: function (
      state: IBrowserState,
      { payload }: SetBrowserData
    ): IBrowserState {
      return {
        ...state,
        browserData: payload.browserData,
      };
    },
  } as any,
  initialState
);

// required for AOT
export function browserManagerReducer(
  state: IBrowserState = initialState,
  action: any
) {
  return reducerFn(state, action);
}

// selectors
const selectFeature = createFeatureSelector<IBrowserState>(BROWSER_MANAGER);

export const getDeviceId = createSelector(
  selectFeature,
  (state: IBrowserState) => state.deviceId
);

export const isMobile = createSelector(selectFeature, (state: IBrowserState) =>
  state.browserData ? state.browserData.isMobile : null
);

export const isTablet = createSelector(selectFeature, (state: IBrowserState) =>
  state.browserData ? state.browserData.isTablet : null
);

export const getPlatform = createSelector(
  selectFeature,
  (state: IBrowserState) =>
    state.browserData ? state.browserData.platform : null
);

export const isMacOS = createSelector(selectFeature, (state: IBrowserState) =>
  state.browserData ? state.browserData.isMacOS : null
);

export const getDevice = createSelector(selectFeature, (state: IBrowserState) =>
  state.browserData ? state.browserData.device : null
);

export const isIE = createSelector(selectFeature, (state: IBrowserState) =>
  state.browserData ? state.browserData.isIE : null
);

export const isFirefox = createSelector(selectFeature, (state: IBrowserState) =>
  state.browserData ? state.browserData.isFirefox : null
);

export const isOnline = createSelector(selectFeature, (state: IBrowserState) =>
  state.browserData ? state.browserData.isOnline : null
);

export const getBrowserInfoHeaders = createSelector(
  selectFeature,
  (state: IBrowserState) =>
    state.browserData ? state.browserData.browserInfoHeaders : null
);
